import { useEffect, useRef, useState } from "react";
import { renderToString } from "react-dom/server";
import { useOktaAuth } from "@okta/okta-react";
import { io } from "socket.io-client";
import "./Chat.css"
import { UpdateTicket } from "../Tickets/UpdateTicket.js";
import { Starters } from "../Starters/Starters.js";
import { Messages, sanitize } from "../Messages/Messages.js";
import { Buttons } from "../Buttons/Buttons.js";
import { Dropdown } from "../Dropdown/Dropdown.js";
import { Feedback } from "../Feedback/Feedback.js";
import { AskEndConversation } from "../AskEndConversation/AskEndConversation.js";
import { StartNewChatModal } from "../StartNewChatModal/StartNewChatModal.js";
import * as microsoftTeams from '@microsoft/teams-js';
import { DateTime } from "luxon";
import { Description } from "../Description/Description.js";
import { CombinedPhoneInput } from "../CombinedPhoneInput/CombinedPhoneInput.js";
import { Disconnectivity } from "../Disconnectivity/Disconnectivity.js";
import he from "he"
import { Constants } from "../Utils/Constants.js";
import { DynamicForm } from "../DynamicForm/DynamicForm.js";
import { IFrameData } from "../IFrame/IFrameData.js";

function Chat() {
  const [messages, setMessages] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isCallbackEnabled, setIsCallbackEnabled] = useState(true);
  const [password, setPassword] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [input, setInput] = useState("");
  const [loader, setLoader] = useState(false);
  const [tick, setTick] = useState(0)
  const [error, setError] = useState('');
  const socketRef = useRef(null);
  const chatBoxRef = useRef(null);
  const [dropdownValue, setDropdownValue] = useState([]);
  const [starters, setStarters] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [backuptickets,setbackuptickets]=useState([]);
  const [singleTicketDetails, setSingleTicketDetails] = useState(null);
  // const [cancelTickets, setCancelTickets] = useState(false)
  const [showTickets, setShowTickets] = useState(true);
  const [userClosedTickets, setUserClosedTickets] = useState(false);
  const [askEndConversation, setAskEndConversation] = useState(false);
  const [feedbackDone, setFeedbackDone] = useState(false);
  const [socketKey, setSocketKey] = useState(0);
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const [startNewChatDialogs, setStartNewChatDialogs] = useState({});
  const [description, setDescription] = useState("");
  const [showDescription, setShowDescription] = useState(false);
  const [customInput, setCustomInput] = useState(null);
  const [socketdisconnect, setSocketDisconnect] = useState(false);
  const fileInputRef = useRef(null);
  // NEW: File state
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState([]);
  const [attachmentData, setAttachmentData] = useState([]);
  const [IsAttachmentEnabled, setIsAttachmentEnabled] = useState(false);
  const [IsPreviewUrlEnable, setIsPreviewUrlEnable] = useState(false);
  const [uploadError, setUploadError] = useState();
  const [fileHoverIndex, setFileHoverIndex] = useState(null);
  const [UIComponent, setUIComponenet] = useState(false);
  const [countryCode, setCountryCode] = useState(null);
  const [ShowNotification, setShowNotification] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const inputRef = useRef(null);
  const [showDynamicForm, setShowDynamicForm] = useState(false);
  const [lookupOptions, setLookupOptions] = useState({});
  const [loadingLookup, setLoadingLookup] = useState({});
  const [isUiDisabled, setisUiDisabled] = useState(false)
  const [uirehydrating,setuirehydrating] = useState(false);
  const skipNextStore = useRef(false);
  const [visibleFieldIds, setVisibleFieldIds] = useState([]);
  const [formId, setFormId] = useState(null);
  const [hasVisibilityExpression, setHasVisibilityExpression] = useState(false);
  const [evaluatingVisibility, setEvaluatingVisibility] = useState(false);
  const [restoredFormValues, setrestoredFormValues] = useState({});
  const [changeticket, setchangeticket] = useState(false);
  const [ticketId, setticketId] = useState({});
  const formDataRef = useRef(null);

  let prevMsg = "";
  const API_BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:8080"
      : window.location.origin;
  const { oktaAuth, authState } = useOktaAuth();
  const token = oktaAuth.getAccessToken();


  useEffect(() => {
    const initTeams = async () => {
      setIsDisabled(true)
      console.log("Trying to initialise teams")
      if (microsoftTeams.app.isInitialized()) {
        console.log("App already initialised")
      }
      else {
        try {
          console.log("Teams not initialised already, trying to initialise now")
          await microsoftTeams.app.initialize();
          microsoftTeams.app.notifySuccess();
          console.log("Teams SDK initialized");
        } catch (err) {
          console.log("Running outside Teams:", err);
        }
      }
    };
    console.log("Inside useeffect")
    initTeams();
  }, []);

  useEffect(() => {
    if (!isDisabled) {
      inputRef.current?.focus();
    }
  }, [isDisabled]);

  useEffect(() => {
  if (!uirehydrating) return;
 
  const timer = setTimeout(() => {
    setuirehydrating(false);
  }, 2000);
 
  return () => clearTimeout(timer);
}, [uirehydrating]);

  useEffect(() => {
    const connectSocket = async () => {
      const userInfo = await oktaAuth.getUser();
      if (!token) {
        console.log("Access token not found");
        await oktaAuth.signInWithRedirect();
        return;
      }
      const THRESHOLD = 15 * 60 * 1000;
      const lastActivityTime = localStorage.getItem("lastActivityTime");
      let correlationId = null;

      if (lastActivityTime) {
        const lastActivity = Number(lastActivityTime);
        const currentTime = Date.now();

        if (currentTime - lastActivity < THRESHOLD) {
          correlationId = localStorage.getItem("correlationId");
        } else {
          localStorage.removeItem("correlationId");
        }
      } else {
        localStorage.removeItem("correlationId");
      }
      socketRef.current = io(API_BASE_URL, {
        transports: ['websocket'],
        auth: {
          "token": token,
          "userinfo": userInfo,
          "correlationId": localStorage.getItem("correlationId"),
          "timeZone": Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        query:{
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      });

      const socket = socketRef.current;

      socket.on("sessionRecreation", (chatTranscript) => {
        let restoredFormValues = {};
        let retrievedMessages = chatTranscript.map((msg) => {
          let parsedContent;
          try {
            parsedContent = JSON.parse(msg.content);
          } catch (e) {
            parsedContent = null;
          }
          if (parsedContent?.type === "formValues") {
            restoredFormValues = parsedContent?.data?.latestFormData;
            return null;
          }
          // UI message
          if (parsedContent?.type === "ui" || parsedContent?.type === "ticket") {
            if (parsedContent?.uiType === "ticket") {
              setTickets(parsedContent.data)
              setbackuptickets(parsedContent.data)
              const hasChangeTicket = Array.isArray(parsedContent.data) && parsedContent.data.some(ticket => ticket.formattedReference?.startsWith("R"));
              setchangeticket(hasChangeTicket);
            }
            if(parsedContent?.uiType === "Form"){
              setShowDynamicForm(true)
            }
            return {
              ...parsedContent,
              from: "bot",
              timestamp: DateTime.fromISO(msg.timestamp)
                .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .toFormat("hh:mm a")
            };
          }

          // Normal text message
          return {
            id: Date.now() + crypto.randomUUID(),
            type: "text",
            text: msg.content,
            from: msg.role === "WYNSTON" ? "bot" : "user",
            timestamp: DateTime.fromISO(msg.timestamp)
              .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
              .toFormat("hh:mm a")
          };
        }).filter(Boolean);
        setrestoredFormValues(restoredFormValues);
        skipNextStore.current = true;
        setuirehydrating(true)
        const lastIndex = retrievedMessages.length - 1
        const lastFormIndex = retrievedMessages.findLastIndex(message => message.uiType === "Form");
        retrievedMessages = retrievedMessages.map((message, index) => message.uiType == "singleTicketDetails" && index!=lastIndex? {...message, transient: true} : message)
        retrievedMessages = retrievedMessages.map((message, index) => message.uiType === "Form" && index !== lastFormIndex ? { ...message, transient: true } : message);
        setMessages(retrievedMessages);
        setIsDisabled(false);

        if (retrievedMessages.length &&
          retrievedMessages[retrievedMessages.length - 1].from === "user") {
          setLoader(true);
        }
      });

      socket.on("correlationId", (correlationId) => {
        localStorage.setItem("correlationId", correlationId)
        localStorage.setItem("lastActivityTime", Date.now())
      })

      socket.on("connect", () => {
        setIsCallbackEnabled(true)
        setSingleTicketDetails(null);
        setShowTickets(true);
        setUserClosedTickets(false);
        setShowFeedback(false);
        setPassword(false);
        // setIsDisabled(false);
        setInput("");
        setError('');
        setLoader(false);
        setCustomInput(null);
        setAskEndConversation(false);
        setFeedbackDone(false);
        setShowRefreshModal(false)
        setSocketDisconnect(false)
        setIsAttachmentEnabled(false)
        setchangeticket(false)
      })
      socket.on("enableAttachment", (data) => {
        if (data) {
          setIsAttachmentEnabled(true)
        }
        else {
          setIsAttachmentEnabled(false)
        }
      })

      socket.on("countryCode", (data)=>{
        setCountryCode(data);
      });
      
      socket.on("iframeLink", (link)=>{
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              id: Date.now() + crypto.randomUUID(),
              type: "ui",
              uiType: "iframe",
              text: link,
              from: "bot",
              timestamp: DateTime.now()
                .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .toFormat("hh:mm a"),
            },
          ]);
        // setIframeLink(link);
      });

      socket.on("user", ({ data, required }) => {
        if (!required) {
          emitMessage(data, "userMessage");
        }
        else {
          emitMessage(data)
        }
      })

      socket.on("message", (msg) => {
        localStorage.setItem("lastActivityTime", Date.now())
        if (msg?.trim() !== "") {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              id: Date.now() + crypto.randomUUID(),
              type: "text",
              text: msg,
              from: "bot",
              timestamp: DateTime.now()
                .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .toFormat("hh:mm a"),
            },
          ]);
          setisUiDisabled(false)
          setAskEndConversation(false);
          setLoader(false);
          setIsDisabled(false);
          setShowFeedback(false);
        }
      });

      socket.on("buttons", (data) => {
        if (data.text.trim() !== "") {
          setMessages((prev) => [...prev, { type: 'text', text: data.text, from: "bot", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
        }
        setButtons(data.buttons);
        setIsDisabled(false);
        setLoader(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            id: Date.now() + crypto.randomUUID(),
            type: "ui",
            uiType: "buttons",
            data: data.buttons,
            from: "bot",
            timestamp: DateTime.now()
              .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
              .toFormat("hh:mm a"),
          },
        ]);
      });

      socket.on("dropdowns", (data) => {
        if (data.text.trim() !== "") {
          setMessages((prev) => [...prev, { type: 'text', text: data.text, from: "bot", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
        }
        setDropdownValue(data.dropdowns);
        setLoader(false);
      });

      socket.on("starters", (data) => {
        if (data.text.trim() !== "") {
          setMessages((prev) => [...prev, { type: 'text', text: data.text, from: "bot", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
        }
        setIsDisabled(false);
        setStarters(data.starters);
        setLoader(false);
      });

      socket.on("feedback", () => {
        setShowFeedback(true)
        setIsDisabled(false);
        setLoader(false);
      })

      socket.on("custom_input", (data) => {
        console.log("Received custom input data:", data);
        if (data.type === 'combined_phone_input') {
          setCustomInput(data);
          setLoader(false);
          setMessages((prevMessages) => [
          ...prevMessages,
          {
            id: Date.now() + crypto.randomUUID(),
            type: "ui",
            uiType: "phoneinput",
            data: data,
            from: "bot",
            timestamp: DateTime.now()
              .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
              .toFormat("hh:mm a"),
          },
        ]);
        }
      });

      socket.on("password", () => {
        setPassword(true)
        setLoader(false);
      })

      socket.on("askEndConversation", () => {
        // setIsDisabled(true);
        setAskEndConversation(true);
      })

      socket.on("ticketId", (data) => {
        socketRef.current.emit("getTicketDetails", data);
      });

      socket.on("setClearTicket", () => {
        setSingleTicketDetails(null);
        setShowTickets(false);
        setTickets([]);
        setUserClosedTickets(true);
      })

      socket.on("set_description", (data) => {
        setDescription(data);
      })
      socket.on("enablecallback", () => {
        console.log("Enabling callback button");
        setIsCallbackEnabled(true);
      });

      socket.on("disablecallback", () => {
        console.log("Disabling callback button");
        setIsCallbackEnabled(false);
      });
      socket.on("PendingDecisions", (data) => {
        if(data === 0){
          setShowNotification(false);
          setPendingCount(data)
        }
        if (data > 0) {
        setShowNotification(true);
        setPendingCount(data)
        playNotificationSound();
        setShowToast(true);
      // Hide toast after 5 seconds
      setTimeout(() => {
        setShowToast(false);
      }, 1500);
    }
      });
      socket.on("ticketsData", (data) => {
        setUserClosedTickets(false);
        setIsDisabled(false);
        // setSingleTicketDetails(null);
        // setTickets([]);
        console.log(data)
        setTickets(data);
        setbackuptickets(data)

        const hasChangeTicket = Array.isArray(data) && data.some(ticket => ticket.formattedReference?.startsWith("R"));
        setchangeticket(hasChangeTicket);

        if (Array.isArray(data) && data.length > 0) {
          setMessages((prevMessages) => [
            ...prevMessages,
            {
              id: Date.now() + crypto.randomUUID(),
              type: "ui",
              uiType: "ticket",
              data,
              from: "bot",
              timestamp: DateTime.now()
                .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .toFormat("hh:mm a"),
            },
          ]);

        }
      });

      socket.on("renderDynamicForm", (data) => {
        console.log("Dynamic form received:", data);
        setLoader(false);
        if (!data || typeof data !== "object") {
          console.error("Expected single ticket details object, got:", data);
          setLoader(false);
          return;
        }
        setShowDynamicForm(true);
        // Store formId and visibility flag if provided
        if (data.formId) setFormId(data.formId);
        if (data.hasVisibilityExpression !== undefined) setHasVisibilityExpression(data.hasVisibilityExpression);
        if (data.customfields) setrestoredFormValues(data.customfields);
        if (data.ticketId) setticketId(data.ticketId)

        setMessages((prevMessages) => [
          ...prevMessages.map((message) => message.uiType == "Form" ? {...message, transient: true} : message),
          {
            id: Date.now() + crypto.randomUUID(),
            type: "ui",
            uiType: "Form",
            transient: false,
            data: data.fields,
            formId: data.formId,
            hasVisibilityExpression: data.hasVisibilityExpression,
            ticketId: data.ticketId,
            changeticket: data.changeticket,
            from: "bot",
            timestamp: DateTime.now()
              .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
              .toFormat("hh:mm a"),
          },
        ]);
        });

      socket.on("singleTicketDetails", (data) => {
        setSingleTicketDetails(null)
        setShowTickets([])
        if (!data || typeof data !== "object") {
          console.error("Expected single ticket details object, got:", data);
          setLoader(false);
          return;
        }

        setIsDisabled(false);

        setMessages((prevMessages) => [
          ...prevMessages.map((message) => message.uiType == "singleTicketDetails" ? {...message, transient: true} : message),
          {
            id: Date.now() + crypto.randomUUID(),
            type: "ui",
            uiType: "singleTicketDetails",
            transient: false,
            data: data,
            from: "bot",
            timestamp: DateTime.now()
              .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
              .toFormat("hh:mm a"),
          },
        ]);

        setLoader(false);
      });

      socket.on("contactUsersResult",(data) => {
        setLookupOptions((prev) => ({
        ...prev,
       [data.fieldId]: data.users
       }));
        setLoadingLookup((prev) => ({
        ...prev,
        [data.fieldId]: false
        }));
      });

      socket.on("visibilityExpressionResult", (data) => {
        // Store the full form properties for filtering
        setVisibleFieldIds(data.formProperties || []);
        setEvaluatingVisibility(false);
      });

      socket.on("error", (error) => {
        setLoader(false)
      })

      socket.on("idletimeout", (data) => {
        setStartNewChatDialogs(data);
        setShowRefreshModal(true);
      })

      socket.on("showDescription", (data) => {
        setLoader(false);
        setDescription(data);
        setShowDescription(true);
      });

      socket.on("disconnection", () => {
        handleModalResponse(true)
      })

      socket.on("disconnect", () => {
        if (isManualResetRef.current) {
          isManualResetRef.current = false;
          return;
        }
        setMessages([]);
        setButtons([]);
        setStarters([]);
        setDropdownValue([]);
        setSingleTicketDetails(null);
        setShowTickets(true);
        setUserClosedTickets(false);
        setShowFeedback(false);
        setPassword(false);
        setIsDisabled(false);
        setInput("");
        setError('');
        setLoader(false);
        setCustomInput(null);
        setAskEndConversation(false);
        setFeedbackDone(false);
        setShowRefreshModal(false)
        setSocketDisconnect(true)
        setchangeticket(false)
        setSocketKey(prev => prev + 1);
      })

      window.addEventListener("beforeunload", () => {
        socket.disconnect();
      });
    }
    connectSocket();
    return () => {
      console.log("Cleaning up old socket");

      if (socketRef.current) {
        socketRef.current.removeAllListeners();
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [oktaAuth, socketKey]);
 
useEffect(() => {
  if(!messages.length) return

  if(skipNextStore.current){
    skipNextStore.current = false;
    return
  };
  const currentIndex = messages.length - 1;

  const msg = messages[currentIndex];
 
  if (msg?.type === "ui" || msg?.type === "ticket" ||  msg?.uiType === 'UserMessage') {
    socketRef.current.emit("storeChatMessage", msg);
  }
 
}, [messages.length]);

  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages, buttons, showFeedback, customInput]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick(t => t + 1);
    }, 60000)

    return () => clearInterval(interval);
  }, [])

  const emitMessage = (message, type = 'text') => {
    localStorage.setItem("lastActivityTime", Date.now())
    socketRef.current.emit("message", { "type": type, "message": message, "token": token })
    setLoader(true);
    setIsDisabled(true);
    setStarters([]);
    setShowFeedback(false);
    // setTickets(null);
    // setCustomInput(null);
    //   setUserClosedTickets(false);
    // if(tickets){
    //   setUserClosedTickets(true)
    //    setMessages((prevMessages) => [...prevMessages, { type: 'text', text: "Listed top 10 tickets", from: "bot", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
    // }
    // setSingleTicketDetails(null)
    // setAskEndConversation(false)
  }

  const handleButtonClick = (value) => {
    if (value === "attach an attachement") {
      fileInputRef.current.click();
      setButtons([]);
      return;
    }
    emitMessage(value);
    setMessages((prev) => [...prev, { type: 'text', text: value, from: "user", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
    setButtons([]);
  };

  const handleFileUpload = async (event) => {
    let files = Array.from(event.target.files || []);
    if (!files?.length) return;

    const MAX_FILES = Constants.ATTACHMENTS.VALUES.MAX_FILES;
    const MAX_TOTAL_SIZE = Constants.ATTACHMENTS.VALUES.MAX_TOTAL_SIZE * 1024 * 1024 // 50MB;
    
    const ALLOWED_EXTENSIONS = Constants.ATTACHMENTS.VALUES.ALLOWED_EXTENSIONS;

    const existingFiles = previewUrl || [];
    const existingCount = existingFiles.length;
    const remainingSlots = MAX_FILES - existingCount;

    if (remainingSlots <= 0) {
      setUploadError(Constants.ATTACHMENTS.MESSAGE.MAX_FILES_REMOVE_ONE_TO_ADD_MORE);
      return;
    }

    if (files.length > remainingSlots) {
      setUploadError(Constants.ATTACHMENTS.MESSAGE.MAX_FILES_EXTRA_NOT_ADDED);
      files = files.slice(0, remainingSlots);
    }

    let existingTotalSize = existingFiles.reduce((sum, item) => sum + (item.size || 0), 0);

    let validFiles = [];
    let currentTotalSize = existingTotalSize;

    for (const file of files) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (!ALLOWED_EXTENSIONS.includes(extension)) {
        setUploadError(`"${file.name}" is not an allowed file type.`);
        continue;
      }
      const isDuplicate = existingFiles.some(        
        (item) => item.fileName === file.name && item.size === file.size
      );
      if (isDuplicate) {
        setUploadError(`"${file.name}" is already attached.`);
        continue;
      }
      if (currentTotalSize + file.size > MAX_TOTAL_SIZE) {
        setUploadError(Constants.ATTACHMENTS.MESSAGE.TOTAL_ATTACHMENT_SIZE_EXCEEDED);
        continue;
      }
      validFiles.push(file);
      currentTotalSize += file.size;
    }

    if (!validFiles.length) return;

    const fileReaders = validFiles.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result.split(",")[1];
            resolve({
              fileName: file.name,
              base64,
              preview: URL.createObjectURL(file),
              type: file.type,
              size: file.size, // needed for size tracking
            });
          };
          reader.readAsDataURL(file);
        })
    );

    const attachments = await Promise.all(fileReaders);
    if (!previewUrl) setPreviewUrl([])
    setPreviewUrl((prev) => [...prev, ...attachments]);
    setAttachmentData((prev) => [...prev, ...attachments]);

  };
  
  const getFileIcon = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
      console.log(ext)
    switch (ext) {
      case "pdf":
        return <img src="/pdf-file.png" className="preview_doc" data-bs-toggle="tooltip" data-bs-placement="top" title={fileName} alt="PDF" />;
      case "doc":
      case "docx":
        return <img src="/docx-file.png" className="preview_doc" data-bs-toggle="tooltip" data-bs-placement="top" title={fileName} alt="DOCX" />;
      case "xls":
      case "xlsx":
        return <img src="/xlsx-file.png" className="preview_doc" data-bs-toggle="tooltip" data-bs-placement="top" title={fileName} alt="Excel" />;
      case "zip":
        return <img src="/zip-file.png" className="preview_doc" data-bs-toggle="tooltip" data-bs-placement="top" title={fileName} alt="ZIP" />;
      case "txt":
        return <img src="/txt-file.png" className="preview_doc" data-bs-toggle="tooltip" data-bs-placement="top" title={fileName} alt="TXT" />;
      default:
        return <img src="/def-file.png" className="preview_doc" data-bs-toggle="tooltip" data-bs-placement="top" title={fileName} alt="File" />;
    }
  };
  const removeFile = (index) => {
    setPreviewUrl((prev) => {
      const updated = prev.filter((_, i) => i !== index);

      if (updated?.length === 0 && fileInputRef.current) {
        fileInputRef.current.value = "";
      }

      return updated;
    });

    setAttachmentData((prev) =>
      prev.filter((_, i) => i !== index)
    );
  };


  const handleDropdownClick = (value) => {
    emitMessage(value);
    setMessages((prev) => [...prev, { type: 'text', text: value, from: "user", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
    setDropdownValue([]);
  };

  // Handle phone number submission from CombinedPhoneInput
  const handlePhoneSubmit = (fullPhoneNumber) => {    
    emitMessage(fullPhoneNumber);
    setMessages((prev) => [...prev, {
      type: 'text',
      text: `Phone: ${fullPhoneNumber}`,
      from: "user",
      timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
    }]);
    setCustomInput(null);
  };

  const handleTicketClick = (ticketId) => {
    if (ticketId === null) {
      setSingleTicketDetails(null);
      return;
    }
    setShowFeedback(false)
    const ticket = tickets.find(t => t.id === ticketId);
    if (ticket) {
      setMessages((prev) => [...prev, {
        type: "ticket",
        data: {
          url: ticket.url,
          formattedReference: ticket.formattedReference,
          shortDescription: ticket.shortDescription
        },
        from: "bot",
        timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
      }]);

      setSingleTicketDetails(ticket);
      setLoader(true)
      socketRef.current.emit("getTicketDetails", ticketId);
    }
  };

  const askTicketId = () => {
    setTickets(null);
    setSingleTicketDetails(null);
    socketRef.current.emit("askTicketId", "Not listed");
  };

  const handleEndConversation = () => {
    setAskEndConversation(false);
    setShowFeedback(true);
    setIsDisabled(true);
  };
  const handleEndCancelConversation = () => {
    setAskEndConversation(false);
    emitMessage("cancel");
  };

  const handleDescriptionUpdate = (data) => {
    setLoader(true);
    setShowDescription(false);
    socketRef.current.emit("DescriptionData", data);
    emitMessage("Updated the description");
  }

  const handleAddDetails = (ticketId, details, actionTypeId, attachment) => {
    try {
      socketRef.current.emit("addTicketDetails", {
        ticketId,
        details,
        actionTypeId,
        attachment
      });
      setisUiDisabled(true)
      setShowFeedback(false)
      setUploadError("");
      setAttachmentData([])
      setPreviewUrl([])
      setIsPreviewUrlEnable(false)
      setIsAttachmentEnabled(false)
      const actionTypeText = actionTypeId === 40 ? "follow-up" : "additional details";
      const userMsg = {
        type: 'text',
        text: `Added ${actionTypeText} to ticket: ${details}`,
        from: "user",
        timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
      }
      setMessages(prev => [...prev, userMsg]);
      socketRef.current.emit("storeChatMessage", userMsg);
      if(attachmentData?.length > 0){
        setMessages((prev) => [...prev, {
        type: 'text',
        text: renderToString(buildAttachmentReferenceText(attachmentData)),
        from: "user",
        timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a"),
        attachmentMessage : true
      }]);
      }
      setIsAttachmentEnabled(false)
      setLoader(true);

      socketRef.current.once("botMessage", (botMsg) => {
        setMessages((prev) => [...prev, {
          type: 'text',
          text: botMsg,
          from: "bot",
          timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
        }]);

        setLoader(true);

        setTimeout(() => {
          const updatedTicket = tickets.find(t => t.id === ticketId);
          if (updatedTicket) {
            setSingleTicketDetails(updatedTicket);
          }
          setLoader(false);
        }, 2000);
      });

    } catch (error) {
      console.error("Error adding details:", error);
      setMessages((prev) => [...prev, {
        type: 'text',
        text: "Failed to add details. Please try again.",
        from: "bot",
        timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
      }]);
      setLoader(false);
    }
  };

  const  handleSubmitDecision = (ticketId,selectedAnswer,details) => {
    try {
      socketRef.current.emit("addSubmitDecision", {
        ticketId,
        selectedAnswer,
        details,
      });
      setisUiDisabled(true)
      setIsAttachmentEnabled(false)
      setMessages((prev) => [...prev, {
        type: 'text',
        uiType: 'UserMessage',
        text: `Adding your decision: ${selectedAnswer} and remarks: ${details} to the ticket`,
        from: "user",
        timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
      }]);
      setLoader(true);

      socketRef.current.once("botMessage", (botMsg) => {
        setMessages((prev) => [...prev, {
          type: 'text',
          text: botMsg,
          from: "bot",
          timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
        }]);

        setLoader(true);
      });

    } catch (error) {
      console.error("Error adding details:", error);
      setMessages((prev) => [...prev, {
        type: 'text',
        text: "Failed to Submit Descisons. Please try again.",
        from: "bot",
        timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a")
      }]);
      setLoader(false);
    }
  };

  const handleCloseAllTickets = () => {
    setSingleTicketDetails(null);
    setShowTickets(false);
    setTickets([]);
    setUserClosedTickets(true);

    return socketRef.current.emit("askFeedbackForTicket");
  };

  const handleFeedback = (rating) => {
    const feedbackLabels = ["Excellent", "Good", "Poor"];
    const feedbackEmojis = ["😀", "😐", "😡"];

    const feedbackText = `${feedbackLabels[rating - 1]} ${feedbackEmojis[rating - 1]}`;
    emitMessage(rating);
    setMessages((prev) => [...prev, { type: 'text', text: feedbackText, from: "user", timestamp: DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat("hh:mm a") }]);
    setShowFeedback(false);
    setIsDisabled(false);
    setFeedbackDone(true);
  };

  const buildAttachmentReferenceText = (attachments) => {
    if (!attachments?.length) return "";

  return (
    <div style={{ display: "flex" }}>
      {attachments.map((a, index) => {
        const isImage = a.type.startsWith("image/");
        return (
          <div key={index}>
            {isImage ? (
              <img
                src={a.preview}
                alt="preview"
                style={{ width: "50px", height: "50px" }}
              />
            ) : (
              getFileIcon(a.fileName)
            )}
          </div>
        );
      })}
    </div>
  );     
  };

  const sendMessage = () => {
    const hasText = input.trim().length > 0;
    const hasAttachments = attachmentData?.length > 0;

    if (hasAttachments && !IsPreviewUrlEnable) {
      emitMessage({
        text: hasText ? input.trim() : undefined,
        attachments: attachmentData.map((attachment) => ({
          fileName: attachment.fileName,
          base64: attachment.base64,
        })),
        type: "text+attachment",
      });

      setIsAttachmentEnabled(false);

      if (hasText) {
        setMessages((prevMessages) => [
          ...prevMessages,
          {
            id: Date.now() + crypto.randomUUID(),
            type: "text",
            text: input.trim(),
            from: "user",
            timestamp: DateTime.now()
              .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
              .toFormat("hh:mm a"),
          },
        ]);
      }

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: Date.now() + crypto.randomUUID(),
          type: "text",
          text: renderToString(buildAttachmentReferenceText(attachmentData)),
          from: "user",
          timestamp: DateTime.now()
            .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .toFormat("hh:mm a"),
          attachmentMessage : true
        },
      ]);
      setAttachmentData([]);
      removeFile();
      setPreviewUrl([]);
      setButtons([]);
      setInput("");
      setPassword(false);
      setCustomInput(null);
      return;
    }
    if (hasText) {
      setAskEndConversation(false);
      emitMessage(input.toLowerCase().trim());

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          id: Date.now() + crypto.randomUUID(),
          type: "text",
          text: input.trim(),
          from: "user",
          timestamp: DateTime.now()
            .setZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .toFormat("hh:mm a"),
        },
      ]);
      setIsAttachmentEnabled(false);
      setIsPreviewUrlEnable(false);
      setAttachmentData([]);
      setPreviewUrl([]);
      setButtons([]);
      setInput("");
      setPassword(false);
      setCustomInput(null);

    }
    else {
      setError("Message field cannot be empty")
    }
  };

  const isManualResetRef = useRef(false)

  const handleStartNewChat = () => {
    setStartNewChatDialogs({
      QUESTION: "Would you like to start a fresh conversation or continue here?",
      YES: "No, Continue",
      NO: "Yes, Start New Chat"
    })
    setShowRefreshModal(true);
    setIsDisabled(true)
  };

  const handleModalResponse = (shouldReset, cancelTickets) => {
    setShowRefreshModal(false);
    if (shouldReset) {
      console.log("Starting new chat...");
      localStorage.removeItem("correlationId");
      isManualResetRef.current = true;
      setMessages([]);
      setButtons([]);
      setStarters([]);
      setDropdownValue([]);
      setTickets([]);
      setSingleTicketDetails(null);
      setShowTickets(true);
      setUserClosedTickets(false);
      setShowFeedback(false);
      setPassword(false);
    // setIsDisabled(false);
      setInput("");
      setError('');
      setLoader(false);
      setCustomInput(null);
      setAskEndConversation(false);
      setFeedbackDone(false);
      setIsCallbackEnabled(true);
      setAttachmentData([])
      setPreviewUrl([])
      setShowDescription(false)
      setSocketDisconnect(false)
      setIsAttachmentEnabled(false)
      setbackuptickets([])
      setShowDynamicForm(false)
      setLookupOptions({})
      setuirehydrating(false)
      setVisibleFieldIds([])
      setFormId(null)
      setHasVisibilityExpression(false)
      setEvaluatingVisibility(false)
      setrestoredFormValues({})
      setticketId({})
      setchangeticket(false)
      setSocketKey(prev => prev + 1);
    }
    else {
      if (startNewChatDialogs.TYPE == "cancel" || cancelTickets) {
        emitMessage("continueWithoutCancel")
        // setCancelTickets(false)
      }
      else {
        emitMessage("clearSpareTimeout")
      }
      setStarters(starters)
      setLoader(false)
      setIsDisabled(false)
      setCustomInput(customInput)
      // setCancelTickets(false)
    }
  };
  const handleCallClick = () => {
    setButtons([])
    emitMessage("Request callback from service desk technician.");
  };
  const Main_Menu = () => {
    setButtons([])
    emitMessage("Go back to Main menu");
  };
  const playNotificationSound = () => {
  const audio = new Audio("/notification.mp3");
  audio.play().catch((err) => console.log("Audio blocked:", err));
};
  const handleShowNotifications = () => {
  setButtons([])
  emitMessage("Fetch pending approvals/Decision");
};

  const handleFormSubmit = (formData) => {
  emitMessage({
    text: "user Submitted",
    payload : {
      customFields: formData.customFields,
      rootLevelFields: formData.rootLevelFields
    },
    type: "form",
  });
};

 const handleModifyForm = (formData) => {
  setLoader(true)
  setIsDisabled(true)
  socketRef.current.emit("modifyValues", {
      customFields: formData.customFields,
      rootLevelFields: formData.rootLevelFields,
      ticketId: formData.ticketId
    });
};

  const handleSearchUser = (fieldId, searchText, systemLookupTypeName, hasFilter, customFields, formId, propertyDefinitionType, isIconClick) => {
  socketRef.current.emit("searchContactUsers", {fieldId,searchText,systemLookupTypeName,hasFilter,customFields,formId,propertyDefinitionType,isIconClick});
  setLoadingLookup((prev) => ({
    ...prev,
    [fieldId]: true
  }));
};

  const handleClearLookup = (fieldId) => {
  setLookupOptions((prev) => ({
    ...prev,
    [fieldId]: []
  }));
};

  const handleFieldChange = (customFields, currentFormId, hasVisibility) => {
    // Only evaluate visibility if the form has visibility expressions
    if (hasVisibility && currentFormId) {
      console.log("Evaluating visibility expression with:", { customFields, formId: currentFormId });
      setEvaluatingVisibility(true);
      socketRef.current.emit("evaluateVisibilityExpression", {
        customFields,
        formId: currentFormId
      });
    }
  };

  const handleFormDataChange = (latestFormData) => {
    formDataRef.current = latestFormData;
    socketRef.current.emit("storeFormValues", {
      latestFormData
    });
  };

  const handlechangeTicketClick = (ticketId) => {
    setShowDynamicForm(false)
    setLoader(true)
    setrestoredFormValues({})
    socketRef.current.emit("changeTicket", ticketId);

    chatBoxRef.current?.scrollTo({
      top: chatBoxRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <div className="chat-wrapper">
      <div className="chat-container card shadow" id="chatPage">
        {/* Header with Start New Chat button */}
        <div className="chat-header d-flex align-items-center p-2 rounded-top shadow-sm position-relative">
          <img
            className="img-fluid ms-3 mb-1"
            src="/assistant-icon.png"
            alt="Assistant Icon"
            width="28"
            height="28"
            style={{ filter: "brightness(0) saturate(100%) invert(34%) sepia(20%) saturate(720%) hue-rotate(168deg) brightness(130%) contrast(88%)", width: "3%", height: "4%" }}
          />
          <h5 className="ms-3 mb-0" style={{ fontWeight: "bold" }}>
            Wynston
          </h5>

          {/* Top Right Icons */}
          <div className="position-absolute top-50 end-0 translate-middle-y me-3 d-flex align-items-center">
            {/* Notification Icon - show only when notifications are available */}
            {ShowNotification && (
              <div
                className="btn btn-sm bg-transparent border-0 me-2 position-relative"
                onMouseEnter={() => setShowToast(true)}
                onMouseLeave={() => setShowToast(false)}
              >
                {/* Animated Bell */}
                <i
                  className="bi bi-bell-fill fs-5"
                  style={{
                    color: "#1E3A5F", // Navy Blue
                    animation: pendingCount > 0 ? "ring 1s ease-in-out infinite" : "none",
                    transformOrigin: "top center"
                  }}
                ></i>
                {showToast && (
                  <div
                    className="position-fixed top-0 end-0 p-3"
                    style={{ zIndex: 9999 }}
                  >
                    <div className="toast show shadow border-0"
                    >
                      <div className="toast-header bg-warning text-dark">
                        <i className="bi bi-bell-fill me-2"></i>
                        <strong className="me-auto">Pending Decisions</strong>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowToast(false)}
                        ></button>
                      </div>
                      <div className="toast-body"
                      onClick={handleShowNotifications}
                      >
                        You have <strong>{pendingCount}</strong> pending decision
                        {pendingCount > 1 ? "s" : ""} waiting for your action.
                      </div>
                    </div>
                  </div>
                )}

                {/* Count Badge */}
                <span className="notification-badge">
                  {pendingCount > 99 ? "99+" : pendingCount}
                </span>
              </div>
            )}
            <button
              className="btn btn-sm bg-transparent border-0 me-2"
              title="Start new chat"
              onClick={handleStartNewChat}
            >
              <i className="bi bi-plus-circle fs-5"></i>
            </button>

            {/* Call Icon */}
            <button className="btn btn-sm bg-transparent border-0"
              title="Call Support"
              disabled={!isCallbackEnabled}
              style={!isCallbackEnabled ? {
                opacity: 0.5,
                cursor: "not-allowed"
              } : {}}
              onClick={handleCallClick}
            >
              <i className="bi bi-telephone-fill fs-5"></i>
            </button>
          </div>
        </div>

        <div id="chat-box" className="chat-box rounded-bottom p-3 mb-3" ref={chatBoxRef}>
          {messages.map((msg, index) => {
            if (msg?.type === "ui" && msg?.uiType === "ticket") {
      return (<UpdateTicket currentIndex={index} allMessages={messages} messages={msg} setIsDisabled={setIsDisabled} socket={socketRef} onTicketClick={handleTicketClick} changeTicketClick={handlechangeTicketClick} askTicketId={askTicketId} setBackTickets={backuptickets} singleTicketDetails={null} setSingleTicketDetails={setSingleTicketDetails} uirehydrating={uirehydrating} isUiDisabled={isUiDisabled} onAddDetails={handleAddDetails} onSubmitDecision={handleSubmitDecision} onCloseAllTickets={handleCloseAllTickets} handleModalResponse={Main_Menu} setLoader={setLoader} ticketAttachment={attachmentData} setIsPreviewUrlEnable= {setIsPreviewUrlEnable}setIsAttachmentEnabled={setIsAttachmentEnabled} setAttachmentData={setAttachmentData} setPreviewUrl={setPreviewUrl} fileInputRef={fileInputRef} getFileIcon={getFileIcon} setUploadError={setUploadError} changeticket={changeticket}/>);
            }

            if (msg?.type === "ui" && msg?.uiType === "singleTicketDetails" && !msg.transient) {
      return (<UpdateTicket currentIndex={index} allMessages={messages} messages={msg} setIsDisabled={setIsDisabled} socket={socketRef} onTicketClick={handleTicketClick} askTicketId={askTicketId} setBackTickets={backuptickets} singleTicketDetails={msg.data} setSingleTicketDetails={setSingleTicketDetails} uirehydrating={uirehydrating} isUiDisabled={isUiDisabled} onAddDetails={handleAddDetails} onSubmitDecision={handleSubmitDecision} onCloseAllTickets={handleCloseAllTickets} handleModalResponse={Main_Menu} setLoader={setLoader} ticketAttachment={attachmentData} setIsPreviewUrlEnable= {setIsPreviewUrlEnable} setIsAttachmentEnabled={setIsAttachmentEnabled} setAttachmentData={setAttachmentData} setPreviewUrl={setPreviewUrl} fileInputRef={fileInputRef} getFileIcon={getFileIcon} setUploadError={setUploadError}/>);
            }

            if (msg?.type === "ui" && msg?.uiType === "Form" && !msg.transient){
       return (<DynamicForm
                currentIndex={index}
                allMessages={messages}
                fields={msg.data}
                showDynamicForm={showDynamicForm}
                onSubmit={handleFormSubmit}
                onModify={handleModifyForm}
                onSearchUser={handleSearchUser}
                lookupOptions={lookupOptions}
                onClearLookup={handleClearLookup}
                loadingLookup={loadingLookup}
                formId={msg.formId}
                hasVisibilityExpression={msg.hasVisibilityExpression}
                ticketId={msg.ticketId}
                onFieldChange={handleFieldChange}
                visibleFieldIds={visibleFieldIds}
                evaluatingVisibility={evaluatingVisibility}
                onFormDataChange={handleFormDataChange}
                restoredFormValues={restoredFormValues}
                changeticket={msg.changeticket}
              />)
            }
           
            if (msg?.type === "ui" && msg?.uiType === "iframe"){
       return (<IFrameData link={msg.text}></IFrameData>)
            }

            if (msg?.type === "ui" && msg?.uiType === "buttons"){ 
       return <Buttons currentIndex={index} allMessages={messages} buttons={msg.data} handleButtonClick={handleButtonClick} />
            }

            if (msg?.type === "ui" && msg?.uiType === "phoneinput"){
            {/* Combined Phone Input Component */}
       return <CombinedPhoneInput phoneData={msg.data} onPhoneSubmit={handlePhoneSubmit} countryCode={countryCode} setCountryCode={setCountryCode} />
            }
            
            return <Messages key={msg.id || index} msg={msg} />;
          })}

          {<input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleFileUpload}
          />}

          {dropdownValue.length > 0 && (
            <Dropdown dropdownValue={dropdownValue} handleDropdownClick={handleDropdownClick} />
          )}

          {starters.length > 0 && (
            <Starters starters={starters} handleButtonClick={handleButtonClick} />
          )}

          {showFeedback && (
            <Feedback handleFeedback={handleFeedback} />
          )}

          {/* {((tickets || singleTicketDetails) && !userClosedTickets) && (
            <UpdateTicket setIsDisabled={setIsDisabled} socket={socketRef} messages={messages} onTicketClick={handleTicketClick} askTicketId={askTicketId} singleTicketDetails={singleTicketDetails} setSingleTicketDetails={setSingleTicketDetails} setBackTickets={setTickets}  onAddDetails={handleAddDetails} onCloseAllTickets={handleCloseAllTickets} handleModalResponse={handleModalResponse} ticketAttachment={attachmentData} setLoader={setLoader}/>
          )} */}

          {askEndConversation && !feedbackDone && (
            <AskEndConversation handleEndConversation={handleEndConversation} handleEndCancelConversation={handleEndCancelConversation} />
          )}

          {showRefreshModal && (
            <StartNewChatModal startNewChatDialogs={startNewChatDialogs} handleModalResponse={handleModalResponse} />
          )}

          {showDescription && (
            <Description description={description} handleDescriptionUpdate={handleDescriptionUpdate} />
          )}

          {socketdisconnect && (
            <Disconnectivity></Disconnectivity>
          )}
                  

          {loader && (
            <div className="bot-avatar">
              <div className="bot-icon">
                <img
                  src="/assistant-icon.png"
                  alt="Assistant"
                  width="28"
                  height="28"
                />
              </div>
              <div className="bot-thinking">
                {Constants.WYNSTONBOTLINE}
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}


        </div>
        <div className="chat-input-main">
        <div className="chat-input-container"
          style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        >
            {uploadError && (
              <div className="upload-error-message upload-error-top">
                {uploadError}
              </div>
            )}

            <div>
              {!IsPreviewUrlEnable && (
                <div className="attachment-preview">
                  {previewUrl &&
                    previewUrl.map((item, index) => {
                      const isImage = (item.type.startsWith("image/"));
                      const isPdf = (item.type === "application/pdf");
                      const fileClass = !isImage ? "attachement_file_class" : "";
                      return (
                        <div key={index} className={`attachment-preview-child ${fileClass}`} onMouseEnter={() => setFileHoverIndex(index)} onMouseLeave={() => setFileHoverIndex(null)}>
                          <div>
                            {isImage && (<img src={item.preview} alt="preview" />)}
                          {!isImage && (getFileIcon(item.fileName))}
                          
                          </div>
                          <div className={!fileClass ? "attachment_image_cls" : ""}>
                            {fileHoverIndex == index && (
                              <i
                                className="bi bi-x-circle-fill attachment-remove-icon"
                                onClick={() => removeFile(index)}
                              ></i>
                            )
                            }

                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              )}

              <input
                disabled={isDisabled}
                ref={inputRef}
                className="chat-input"
                placeholder="Ask your question..."
                value={input}
                onChange={(e) => {
                  setInput(e.target.value);
                  setError("");
                  setUploadError("");

                }}
                onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              />

              {/* <input
              type={password ? "password" : "text"}
              disabled={isDisabled}
              style={isDisabled ? { cursor: "not-allowed" } : {}}
              className="chat-input me-2 flex-grow-1 m-2"
              placeholder="Ask your question..."
              value={input}
              onChange={(e) => {
                setInput(e.target.value);
                setError('');
              }}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              required
            /> */}

              {<input
                type="file"
                multiple
                ref={fileInputRef}
                style={{ display: "none" }}
                accept=".png,.jpg,.jpeg,.pdf,.zip,.doc,.docx,.xls,.xlsx,.txt"
                onChange={handleFileUpload}
              />}
            </div>
          </div>
          <div className="chat-input-btns">
            <span
              title={IsAttachmentEnabled ? "Attach a file" : "Attachments can be added only while creating or updating a ticket."}
              style={{ display: "inline-block" }}
            >
              <button
                className="attachment-btn"
                aria-disabled={!IsAttachmentEnabled}
                style={!IsAttachmentEnabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}

                onClick={() => {
                  setUploadError("");
                  if (IsAttachmentEnabled) {
                    fileInputRef.current?.click();
                  }
                }}

                aria-label="Attach a file"
              >
                <i className="bi bi-paperclip wynston-btn" />
              </button>
            </span>
            <span>
              <button type="button" className="btn" onClick={() => {setUploadError(""); sendMessage()}}>
                <i className="bi bi-send wynston-btn wynston-send-btn"></i>
              </button>
            </span>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Chat;
